import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function Productcard(props) {
    const navigate = useNavigate();
  return (
    <div className='card m-2 cursor-pointer' style={{width:300}} role='button' onClick={() => navigate(`/product/${props.id}`)}>
        <div className='m-2'>
            <img src={props.thumbnail} height={150} width={180} alt={props.title} className='border-radius-9'/>
        </div>
        <div className='card-body'>
            <h5 className='card-title'>{props.title}</h5>
            <h6 className='mt-2'>Price: ${props.price}</h6>
            <h6>Discount: {props.discountPercentage}%</h6>
            <h6>Rating: {props.rating}<img src='https://icon-library.com/images/star-rating-icon/star-rating-icon-3.jpg' height={25} width={25}/></h6>
            <h6>Stock: {props.stock}</h6>
            <h6>Brand: {props.brand}</h6>
            <h6>Category: {props.category}</h6>
            <div className='mt -4'>
                {props.stock > 0 ? 
                
                <button className='btn btn-success'>Buy Now</button> :
                <button className='btn btn-danger'>Out of Stock</button>}
            </div>
        </div>
    </div>
  )
}
